import React from 'react';

import ProductListAllWrap from '../../views/product/list/all/ProductAllListWrap';

const ProductAllListContainer = () => {
  return <ProductListAllWrap />;
};

export default ProductAllListContainer;
